// Approvals API — Standing Goals Agent (Phase B bounded autonomy)
// A goal running under authorization_policy.mode != 'auto_within_bounds' (or
// one whose plan fell outside its bounds) queues its write plan here instead
// of applying it. See docs/specs/01-standing-goals-agent-readiness.md §4.4/4.5.

import { authenticatedFetch } from './authenticatedFetch';
import type { ProposedPlan } from './agent';

const AUTONOMY = '/api/v1/agent/autonomy';

export interface PendingApproval {
  id: string;
  task_id: string | null;
  goal_id: string | null;
  goal_title: string | null;
  task_name: string | null;
  status: 'needs_approval' | 'running' | 'completed' | 'failed';
  approval_status: 'pending';
  credits_spent: number;
  prompt: string;
  proposed_plan: ProposedPlan | null;
  created_at: string;
}

export interface ApprovalDecisionResult {
  success: boolean;
  decision: 'approved' | 'rejected';
  run_id: string;
  status?: 'completed' | 'failed';
  final_answer?: string | null;
  credits_spent?: number;
  write_tools?: string[];
  remembered_bounds?: boolean;
  expired?: boolean;
}

export async function listApprovals(limit = 50): Promise<PendingApproval[]> {
  const data = await authenticatedFetch<{ approvals: PendingApproval[] }>(
    `${AUTONOMY}/approvals?limit=${limit}`,
    { serviceName: 'Approvals' },
  );
  return data.approvals;
}

export async function decideApproval(
  runId: string,
  decision: 'approve' | 'reject',
  rememberBounds = false,
): Promise<ApprovalDecisionResult> {
  return authenticatedFetch(`${AUTONOMY}/approvals/${encodeURIComponent(runId)}/decide`, {
    method: 'POST',
    body: JSON.stringify({ decision, remember_bounds: rememberBounds }),
    serviceName: 'Approvals',
  });
}
